<template>
  <sub-page title="就业创业证查询">
    <div class="cert-page">
      <div class="cert-title">江苏电子就业创业证</div>

      <div class="cert-card">
        <div class="photo">
          <svg viewBox="0 0 24 24" class="photo-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="cert-info">
          <div class="info-row"><span class="label">姓名：</span><span class="value">戴义杰</span></div>
          <div class="info-row"><span class="label">身份证号：</span><span class="value">3411**********5619</span></div>
          <div class="info-row"><span class="label">性别：</span><span class="value">男</span></div>
          <div class="info-row"><span class="label">出生日期：</span><span class="value">1992-10-28</span></div>
          <div class="info-row"><span class="label">发证日期：</span><span class="value">2020-05-26</span></div>
          <div class="info-row"><span class="label">发证机构：</span><span class="value">南京市人力资源和社会保障局</span></div>
          <div class="info-row"><span class="label">证书编号：</span><span class="value">32011130170006007</span></div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">户籍性质/户籍地址情况</div>
        <div class="table">
          <div class="table-row">
            <span class="table-label">户籍性质</span>
            <span class="table-value">外省农村</span>
          </div>
          <div class="table-row">
            <span class="table-label">详细地址</span>
            <span class="table-value">经济技术开发区分局新港派出所</span>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">常驻地址情况</div>
        <div class="table">
          <div class="table-row">
            <span class="table-label">详细地址</span>
            <span class="table-value">南京高新技术产业开发区内南京软件园2号楼A座一层</span>
          </div>
        </div>
      </div>

      <!-- 就业失业登记明细 -->
      <template v-if="showDetail">
        <div class="section">
          <div class="section-title">当前就业登记信息</div>
          <div class="table">
            <div class="table-row">
              <span class="table-label">登记状态</span>
              <span class="table-value txt-green">就业中</span>
            </div>
            <div class="table-row">
              <span class="table-label">就业单位</span>
              <span class="table-value">江苏超芯星半导体有限公司</span>
            </div>
            <div class="table-row">
              <span class="table-label">就业类型</span>
              <span class="table-value">单位就业</span>
            </div>
            <div class="table-row">
              <span class="table-label">登记日期</span>
              <span class="table-value">2024-03-20</span>
            </div>
            <div class="table-row">
              <span class="table-label">经办机构</span>
              <span class="table-value">南京市江北新区社会事业局</span>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">就业失业登记历史</div>
          <div class="timeline">
            <div class="tl-item" v-for="(rec, idx) in history" :key="idx">
              <div :class="['tl-dot', rec.type === '就业登记' ? 'dot-green' : 'dot-orange']"></div>
              <div class="tl-body">
                <div class="tl-head">
                  <span :class="['tl-tag', rec.type === '就业登记' ? 'tag-green' : 'tag-orange']">{{ rec.type }}</span>
                  <span class="tl-date">{{ rec.date }}</span>
                </div>
                <div class="tl-line">{{ rec.desc }}</div>
                <div class="tl-line sub">经办机构：{{ rec.agency }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="footer-btn">
        <button class="detail-btn" @click="showDetail = !showDetail">{{ showDetail ? '收起详情' : '查看详情' }}</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'JobCertQuery',
  components: { SubPage },
  data() {
    return {
      showDetail: false,
      history: [
        { type: '就业登记', date: '2024-03-20', desc: '江苏超芯星半导体有限公司（专业技术人员），当前有效', agency: '南京市江北新区社会事业局' },
        { type: '失业登记', date: '2024-03-01', desc: '与中锗科技有限公司解除劳动合同，办理失业登记', agency: '南京市溧水区人力资源和社会保障局' },
        { type: '就业登记', date: '2021-06-04', desc: '中锗科技有限公司（专业技术人员），2024-02-29 注销', agency: '南京市溧水区人力资源和社会保障局' },
        { type: '失业登记', date: '2021-06-02', desc: '与南京思柏瑞信息科技有限公司合同期满，办理失业登记', agency: '南京市鼓楼区人力资源和社会保障局' },
        { type: '就业登记', date: '2019-09-05', desc: '南京思柏瑞信息科技有限公司（专业技术人员），2021-05-31 注销', agency: '南京市鼓楼区人力资源和社会保障局' }
      ]
    }
  }
}
</script>

<style scoped>
.cert-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.cert-title {
  font-size: calc(40 * var(--w));
  color: #2E8CF6;
  font-weight: bold;
  text-align: center;
  padding: calc(40 * var(--w)) 0;
}
.cert-card {
  display: flex;
  background: #fff;
  margin: 0 calc(24 * var(--w));
  border-radius: calc(12 * var(--w));
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
}
.photo {
  width: calc(160 * var(--w));
  height: calc(200 * var(--w));
  background: #f2f2f2;
  border-radius: calc(8 * var(--w));
  overflow: hidden;
  flex-shrink: 0;
}
.photo-icon {
  width: 100%;
  height: 100%;
}
.cert-info {
  flex: 1;
}
.info-row {
  display: flex;
  align-items: center;
  font-size: calc(26 * var(--w));
  line-height: 1.8;
}
.label {
  color: #969799;
  white-space: nowrap;
}
.value {
  color: #323233;
}
.section {
  margin-top: calc(24 * var(--w));
  padding: 0 calc(24 * var(--w));
}
.section-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(16 * var(--w));
}
.table {
  background: #fff;
  border-radius: calc(12 * var(--w));
}
.table-row {
  display: flex;
  align-items: center;
  min-height: calc(100 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.table-row:last-child {
  border-bottom: none;
}
.table-label {
  font-size: calc(28 * var(--w));
  color: #969799;
  width: calc(200 * var(--w));
  flex-shrink: 0;
}
.table-value {
  flex: 1;
  font-size: calc(28 * var(--w));
  color: #323233;
  text-align: right;
}
.txt-green {
  color: #07A35A;
  font-weight: bold;
}
.timeline {
  background: #fff;
  border-radius: calc(12 * var(--w));
  padding: calc(16 * var(--w)) calc(32 * var(--w));
}
.tl-item {
  display: flex;
  gap: calc(20 * var(--w));
  padding: calc(20 * var(--w)) 0;
  border-bottom: 1px dashed #ebedf0;
}
.tl-item:last-child {
  border-bottom: none;
}
.tl-dot {
  width: calc(20 * var(--w));
  height: calc(20 * var(--w));
  border-radius: 50%;
  margin-top: calc(8 * var(--w));
  flex-shrink: 0;
}
.dot-green {
  background: #07A35A;
}
.dot-orange {
  background: #ff976a;
}
.tl-body {
  flex: 1;
}
.tl-head {
  display: flex;
  align-items: center;
  gap: calc(16 * var(--w));
  margin-bottom: calc(8 * var(--w));
}
.tl-tag {
  font-size: calc(24 * var(--w));
  padding: calc(4 * var(--w)) calc(16 * var(--w));
  border-radius: calc(8 * var(--w));
}
.tag-green {
  color: #07A35A;
  background: #E9F9F0;
}
.tag-orange {
  color: #D88230;
  background: #FFF3EB;
}
.tl-date {
  font-size: calc(24 * var(--w));
  color: #969799;
}
.tl-line {
  font-size: calc(26 * var(--w));
  color: #323233;
  line-height: 1.7;
}
.tl-line.sub {
  color: #969799;
  font-size: calc(24 * var(--w));
}
.footer-btn {
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.detail-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/JobCertQuery.vue